// app/studente/studenteDetail.js

(function () {
    'use strict';
    var controllerId = 'dashboard_Commercial';
    angular.module('app').controller(controllerId, ['$rootScope', 'common', '_', '$scope', '$filter', '$routeParams', '$location', 'datacontext', 'sectionMenu', '$uibModal', 'bootstrap.dialog', dashboard_Commercial]);

    function dashboard_Commercial($rootScope, common, _, $scope, $filter, $routeParams, $location, datacontext, sectionMenu, $uibModal, bDialog) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        $rootScope.dashview = " dashview";
        var vm = this;
        vm.title = 'Supervisore';
        vm.sectionMenu = sectionMenu.setSection('');

        //filter per Anno: default l'anno corrente        
        vm.filter = {};
        vm.fAnno = $rootScope.annoCorrente || (new Date).getFullYear();
        vm.filter.anno = vm.fAnno;

        vm.getAll = getAllFunc;
        vm.acquista = acquista;

        vm.dashboard = {};
        vm.dashboard.numClassi = 0;
        vm.dashboard.numCorsi = 0;
        vm.dashboard.numRisorse = 0;
        vm.dashboard.numStudenti = 0;

        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getDashboard()];
            common.activateController(promises, controllerId)
                    .then(function () { });
        }

        //****************************************************
        // METODI 
        //****************************************************

        function getAllFunc() {
            vm.filter.anno = vm.fAnno == null ? -1 : vm.fAnno;

            getDashboard();            
        }

        function getDashboard() {
            datacontext.dashboard_getCommerciale(vm.filter.anno).then(function (data) {                
                vm.dashboard = data;
            });
        }

        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function acquista() {                        
            var modalInstance = $uibModal.open({
                backdrop: 'static',
                keyboard: false,
                templateUrl: '/app/dashboard/modal/ordineCAdd.html?version=43',
                controller: 'ordineCAdd'
            });

            modalInstance.result.then(function (returnItem) {                
                var msg = "Confermi la vendita della licenza al docente " + returnItem.docente + " per la durata di 1 anno e di aver ricevuto i contanti?";
                bDialog.confirmationDialog("Conferma vendita", msg, "OK").then(function () {
                    vm.loading = true;
                    
                    datacontext.ordine_calcolaCommerciale(returnItem.docenteId).then(function (data) {
                        if (data == null || data == '400' || data == '500') {
                            logError("Impossibile processare l'ordine");
                            vm.loading = false;
                            return;
                        }
                        returnItem.StrumF = 'C';
                        datacontext.ordine_postContanti(returnItem).then(function (data) {
                            if (data == null || data == '400' || data == '500') {
                                logError("Impossibile processare l'ordine");
                                vm.loading = false;
                                return;
                            }
                            else {
                                logSuccess("Ordine completato");
                                vm.loading = false;
                                $location.path("/riepilogoOrdine");
                            }
                        });
                    });
                });
            });
        }
    }
})();